module.exports = __webpack_public_path__ + "static/media/VerySad.52dfe235.png";